import { api } from './api';

export type ContentSourceStatus = 'active' | 'paused';

export interface ContentSource {
  id: number;
  strategy_id: number | null;
  source_type: string;
  name: string;
  url: string;
  fetch_interval_hours: number;
  last_fetched_at: string | null;
  status: ContentSourceStatus;
  created_at: string;
  // Server-berechnet (api/routers/content_sources.py): source_type in PAID_SOURCE_TYPES.
  kostet: boolean;
}

export interface ContentSourceInput {
  source_type: string;
  name: string;
  url: string;
  fetch_interval_hours?: number;
  strategy_id?: number | null;
}

export const contentSourcesApi = {
  list: (status?: ContentSourceStatus) =>
    api.get<{ sources: ContentSource[]; types: string[] }>(
      `/sources${status ? `?status=${status}` : ''}`
    ),

  create: (data: ContentSourceInput) => api.post<ContentSource>('/sources', data),

  update: (id: number, data: { status?: ContentSourceStatus; fetch_interval_hours?: number }) =>
    api.patch<{ ok: boolean; status: ContentSourceStatus | null; fetch_interval_hours: number | null }>(
      `/sources/${id}`,
      data
    ),

  remove: (id: number) => api.delete<{ ok: boolean }>(`/sources/${id}`),

  fetchNow: (id: number, maxItems?: number) =>
    api.post<{ neu: number; bekannt: number; gefunden: number; skipped_paid?: boolean }>(
      `/sources/${id}/fetch`,
      { max_items: maxItems }
    ),
};
